<template>
  <PageTemplate>
  <div class="in-content-warpper">
    <div class="row">
      <div class="des">
        <div class="title">
          智能自助借还系统 型号：V3.0
        </div>
        <el-row style="height:30px"></el-row>
        <p>软件功能描述：</p>
        <el-row style="height:10px"></el-row>
        <p>1.显示屏提供良好的视觉交互提示，并配声音或文字提示；</p>
        <el-row style="height:10px"></el-row>
        <p>2.借书流程：同时放上多本待借图书和读者证，系统在少于2秒内完成借书操作，同时显示该读者在借图书信息；读者无需进行任何键盘或触屏操作，有RFID借书证、人脸识别等借书方式；</p>
        <el-row style="height:10px"></el-row>
        <p>3.还书流程：同时放上多本待还图书，系统在少于2秒内完成还书操作，同时显示该读者剩余未还图书信息；读者无需进行任何键盘或触屏操作，最多可同时识别20本图书；</p>
        <el-row style="height:10px"></el-row>
        <p>4.提醒标识：系统外借多本图书时，对出现有未还图书的情况，能够进行颜色区分和语音提示，系统归还多本图书时，对出现有已还图书的情况，能够进行颜色区分和语音提示；</p>
        <el-row style="height:10px"></el-row>
        <p>5.钣金喷漆工艺，8mm钢化玻璃，丝印；</p>
        <el-row style="height:10px"></el-row>
        <p>6.支持 ISO15693、ISO14443A 和ISO18000-3 标准</p>
        <el-row style="height:10px"></el-row>
        <p>7.分辨率为1920×1080；</p>
        <el-row style="height:10px"></el-row>
        <p>8.机身外部可定制logo。</p>
      </div>
      <div class="img">
        <el-image :src="url2" fit="contain"></el-image>
      </div>
    </div>
  </div>
  </PageTemplate>
</template>
<script>
import PageTemplate from '@/components/PageTemplate'
export default {
  components:{PageTemplate},
  name: 'GuanLi',
  data () {
    return {
      url2: require('../assets/20220822_2.png')
    }
  },
  created () {
  },
  beforeDestroy () {
  }
}
</script>
<style lang="scss">
  .in-content-warpper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #ffffff;
    .row {
      width: 100%;
      height: 500px;
      display: flex;
      flex-direction: row;
      justify-content:space-between;
      align-items: center;
      .img {
        width: 500px;
        height: 340px;
        // background-color: #f2f2f2;
        .el-image {
          width: 500px;
          height: 340px;
        }
      }
      .des {
        width: 600px;
        text-align: left;
        margin-left: 100px;
        padding-top: 1;
        line-height: 1.2;
        .title{
          font-size: 25px;
          font-weight: 600;
          color: #000;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/2.vue